import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Row from '~/elements/Row';
import Link from '~/elements/Link';
import cupomFiscal from '~/static/cupom-fiscal.png';
import FormBuscaCNPJ from '~/compositions/FormBuscaCNPJ';
import Header from '~/compositions/Header';
import { Container as DefaultContainer } from '~/pages/common';
import Loader from '~/components/Loader';
import {
  PageContainer,
  FormContainer,
  TitleContainer,
  Title,
  BackIcon,
  Description,
  Container,
} from './commonStyles';
import { BreadcrumbsContext } from '~/providers/BreadcrumbsProvider';

const ImgStyled = styled.img`
  max-width: 260px;
  margin-top: 24px;
  @media (max-width: 1024px) {
    width: 100%;
    margin-top: 10px;
  }
`;

const StyledRow = styled(Row)`
  margin-bottom: 5rem;
  margin-top: 2.66rem;
`;

const Subtitle = styled.h4`
  color: ${({ theme }) => theme.colors.gray400};
  font-size: 1rem !important;
  font-weight: 500;
  margin-top: 60px;
`;

const StyledGrid = styled(Grid)`
  @media (max-width: 1024px) {
    margin-bottom: 40px;
  }
`;
const LinkCNPJ = styled(Link)`
  margin-left: 0;
`;

function BuscaCNPJ() {
  const history = useHistory();
  const breadcrumbs = useContext(BreadcrumbsContext);
  const isLoading = useSelector(state => state.loading);

  function setBreadcrumb(icon, label) {
    breadcrumbs.setBreadcrumb({
      icon,
      label,
    });
  }

  useEffect(() => {
    setBreadcrumb('store', 'Indique um estabelecimento');
    return () => setBreadcrumb();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Container>
        <Header />
      </Container>
      <PageContainer>
        <DefaultContainer fullWidth>
          <Loader isLoading={isLoading}>
            <FormContainer>
              <TitleContainer>
                <BackIcon
                  onClick={() => history.goBack()}
                  icon={['fas', 'chevron-left']}
                />
                <Title>Indique um estabelecimento</Title>
              </TitleContainer>
              <Description>
                Insira os dados abaixo e indique um estabelecimento para fazer
                parte da nossa rede credenciada. Não esqueça de selecionar quais
                tipos de cartão você deseja utilizar e o tipo de estabelecimento
                que está cadastrando.
              </Description>
              <StyledRow noPadding>
                <StyledGrid>
                  <FormBuscaCNPJ />
                  <LinkCNPJ to="/indique/endereco" uppercase="true">
                    Não tenho o CNPJ
                  </LinkCNPJ>
                </StyledGrid>
                <StyledGrid>
                  <Subtitle>Onde encontrar?</Subtitle>
                  <ImgStyled src={cupomFiscal} alt="Cupom fiscal" />
                </StyledGrid>
              </StyledRow>
            </FormContainer>
          </Loader>
        </DefaultContainer>
      </PageContainer>
    </>
  );
}

export default BuscaCNPJ;
